export default "__VITE_ASSET__f8419f5a__"